(function () {
  if (window.__ampRewardsCurrencyInitialized) return;
  window.__ampRewardsCurrencyInitialized = true;

  function getDocumentLang() {
    var htmlLang = document.documentElement.getAttribute('lang');
    if (htmlLang) return htmlLang.toLowerCase();
    if (window.Shopify && window.Shopify.locale) return window.Shopify.locale.toLowerCase();
    return 'fr';
  }

  function getActiveCurrency() {
    return window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
  }

  function getShopCurrency() {
    return window.Shopify && window.Shopify.currency && window.Shopify.currency.shop;
  }

  function getCurrencyRate() {
    var rate = window.Shopify && window.Shopify.currency && window.Shopify.currency.rate;
    return Number(rate) || 1;
  }

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat((window.Shopify && window.Shopify.locale) || getDocumentLang(), {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (e) {
      return String(cents / 100);
    }
  }

  function getSlideCartState() {
    if (typeof window.SLIDECART_STATE !== 'function') return null;
    try {
      return window.SLIDECART_STATE();
    } catch (e) {
      return null;
    }
  }

  function getSlideCartSettings() {
    var state = getSlideCartState();
    return state && state.settings;
  }

  function getMarketTierKey() {
    var marketId = window.SLIDECART_MARKET_ID;
    if (!marketId) return null;

    return String(marketId).startsWith('gid://')
      ? String(marketId)
      : 'gid://shopify/Market/' + marketId;
  }

  function getMarketRewardTiers() {
    var settings = getSlideCartSettings();
    if (!settings || settings.rewards_same_tiers_for_all_markets !== false) return null;

    var key = getMarketTierKey();
    if (!key || !settings.rewards_tiers_by_market) return null;

    var market = settings.rewards_tiers_by_market[key];
    return market && Array.isArray(market.tiers) ? market.tiers : null;
  }

  function getRewardTiers() {
    var settings = getSlideCartSettings();
    var tiers = settings && settings.rewards_tiers;
    return Array.isArray(tiers) ? tiers : null;
  }

  function resolveRewardTiers() {
    return getMarketRewardTiers() || getRewardTiers();
  }

  function hasMarketSpecificTiers() {
    return Boolean(getMarketRewardTiers());
  }

  function getThresholdRate() {
    if (hasMarketSpecificTiers()) return 1;

    var active = getActiveCurrency();
    var shop = getShopCurrency();

    if (active && shop && active !== shop) return getCurrencyRate();

    return getCurrencyRate() !== 1 ? getCurrencyRate() : 1;
  }

  function getTierThresholdCents(isItemCount, tier, rate) {
    if (!tier) return 0;
    if (isItemCount) return Number(tier.count_amount) || 0;

    var baseAmount = Number(tier.amount);
    if (!baseAmount || Number.isNaN(baseAmount)) return 0;

    return Math.round(baseAmount * rate * 100);
  }

  function updateRewardsDisplay() {
    var root = document.getElementById('slidecarthq');
    if (!root) return;

    var settings = getSlideCartSettings();
    var tiers = resolveRewardTiers();
    if (!settings || !tiers || !tiers.length) return;

    var rate = getThresholdRate();
    var currency = getActiveCurrency() || getShopCurrency();

    root.querySelectorAll('.rewards-tiers-labels-item-amount').forEach(function (el, index) {
      var tier = tiers[index];
      if (!tier || tier.count_amount) return;

      var cents = getTierThresholdCents(false, tier, rate);
      el.innerHTML = formatMoney(cents, currency);
    });
  }

  var rewardsUpdateTimer;
  var isUpdatingRewards = false;

  function scheduleRewardsUpdate() {
    window.clearTimeout(rewardsUpdateTimer);
    rewardsUpdateTimer = window.setTimeout(runRewardsUpdate, 0);
  }

  function runRewardsUpdate() {
    var attempts = 0;

    function run() {
      isUpdatingRewards = true;
      updateRewardsDisplay();
      isUpdatingRewards = false;
      attempts += 1;

      if (
        attempts < 10 &&
        document.getElementById('slidecarthq') &&
        !document.querySelector('#slidecarthq .rewards-tiers-labels-item-amount')
      ) {
        window.setTimeout(run, 100);
      }
    }

    run();
  }

  function observeSlideCart() {
    var root = document.getElementById('slidecarthq');
    if (!root || root.__ampRewardsObserver) return;

    root.__ampRewardsObserver = new MutationObserver(function () {
      if (isUpdatingRewards) return;
      scheduleRewardsUpdate();
    });

    root.__ampRewardsObserver.observe(root, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function chainCallback(name, fn) {
    var previous = window[name];
    window[name] = function () {
      if (typeof previous === 'function') previous.apply(this, arguments);
      fn.apply(this, arguments);
    };
  }

  chainCallback('SLIDECART_LOADED', function () {
    scheduleRewardsUpdate();
    observeSlideCart();
  });
  chainCallback('SLIDECART_UPDATED', scheduleRewardsUpdate);
  chainCallback('SLIDECART_OPENED', scheduleRewardsUpdate);
})();
